
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect, useState } from "react"
import { NextPage } from "next"
import Head from "next/head"
import useTranslation from "next-translate/useTranslation"
import classnames from "classnames"
import Header from "@/pagesComp/index/components/Header"
import Footer from "@/pagesComp/index/components/Footer"
import FormatList from "@/pagesComp/index/components/FormatList"
import QualityList from "@/pagesComp/index/components/QualityList"
import FileUpload from "@/pagesComp/index/components/FileUpload"
import FileItem, { ConvertDataStatus } from "@/pagesComp/index/components/FileUpload/components/FileItem"
import Mp4Page from "@/pagesComp/index/components/Mp4Page"
import styles from "./index.module.scss"
import { eventBus } from "@/utils/eventBus"
import { saClick } from "@/pagesComp/index/utils/sensors"
import { GetServerSideProps, GetServerSidePropsContext } from "next"
import axios from "axios"

export const formats = [
  {
    label: "MP3",
    value: "MP3",
    targetValue: "mp3",
  },
  {
    label: "Ringtone for Android",
    value: "Ringtone for Android",
    targetValue: "mp3",
  },
  {
    label: "Ringtone for iPhone",
    value: "Ringtone for iPhone",
    targetValue: "mp3",
  },
  {
    label: "Audio for PC",
    value: "Audio for PC",
    targetValue: "mp3",
  },
  {
    label: "M4A",
    value: "M4A",
    targetValue: "m4a",
  },
]

export const sizeLists = [
  {
    label: "quality low",
    size: "64 kbps",
    value: 64,
  },
  {
    label: "quality good",
    size: "128 kbps",
    value: 128,
  },
  {
    label: "quality high",
    size: "320 kbps",
    value: 320,
  },
]

interface Mp3PageProps {
  mainTitle: any
  postData: any
  seoData: any
}

const Mp3Page: NextPage<Mp3PageProps> = ({ mainTitle, postData, seoData }) => {
  const { t }: { t: I18nType } = useTranslation("common")
  const [isConvert, setIsConvert] = useState(false)
  const [fileList, setFileList] = useState<File[]>([])
  const [isAllFailed, setIsAllFailed] = useState(false)
  const [formatIndex, setFormatIndex] = useState(0)
  const [sizeIndex, setSizeIndex] = useState(0)
  const [showWarnTips, setShowWarnTips] = useState(false)
  const [isMobile, setIsMobile] = useState(true)
  const [formatIndexArr, setFormatIndexArr] = useState<number[]>([])
  const [qualityIndexArr, setQualityIndexArr] = useState<number[]>([])
  const [optionVisible, setOptionVisible] = useState(false)
  const [uploadStatus, setUploadStatus] = useState(false)

  useEffect(() => {
    eventBus.on("file-warn-tips", eventListener)

    setIsMobile(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
        navigator.userAgent
      )
    )

    return () => {
      eventBus.removeListener("file-warn-tips", eventListener)
    }
  }, [])

  useEffect(() => {
    if (showWarnTips) {
      setTimeout(() => {
        eventBus.emit("file-warn-tips", false)
      }, 3000)
    }
  }, [showWarnTips])

  useEffect(() => {
    const bool = [...fileList].every(e => !(e.type.startsWith("audio/") || e.type.startsWith("video/")))
    setIsAllFailed(bool)
  }, [fileList])
  useEffect(() => {
    // 转换过程，x 掉全部文件，直接回到初始选择文件按钮
    if (isConvert && !fileList.length) setIsConvert(false)
  }, [isConvert, fileList])

  function eventListener(bool: boolean) {
    if (process.browser && window.innerWidth > 760) return

    setShowWarnTips(bool)
  }

  const fileListHandler = (e: FileList) => {
    const files: File[] = []
    fileList.forEach(e => {
      files.push(e)
    })

    function existFile(fList: File[], file: File) {
      return fList.some(e => e.name === file.name && e.size === file.size)
    }

    // 去重处理
    for (const val of e) {
      if (!existFile(files, val)) {
        files.push(val)
      }
    }

    setFileList(files)
  }

  const onConvert = () => {
    if (!fileList.length) return
    if (isAllFailed) return

    // 过滤不符合格式的文件
    let temp1
    let temp2
    const list = Array.prototype.filter.call(fileList, (e, i) => {
      if (e.type.startsWith("audio/") || e.type.startsWith("video/")) {
        return true
      }
      // 安卓下筛选掉图片文件所选择的格式和码率
      temp1 = formatIndexArr.filter((_, index) => index !== i)
      temp2 = qualityIndexArr.filter((_, index) => index !== i)
      return false
    })
    if (temp1 && temp2) {
      setFormatIndexArr((temp1 as unknown) as number[])
      setQualityIndexArr((temp2 as unknown) as number[])
    }
    setFileList(list as any)
    setIsConvert(true)
    window.scrollTo(0, 0)

    saClick("core", "button", "convert", { time: list.length })
  }

  const convertMore = () => {
    setIsConvert(false)
    setFileList([])
    setFormatIndexArr([])
    setQualityIndexArr([])

    saClick("core", "button", "conv_more")
  }

  // 文件状态为 UPLOADING 或 CONVERTING 不显示 convert more 按钮
  const statusFn = (status: ConvertDataStatus) => {
    if (status === ConvertDataStatus.UPLOADING || status === ConvertDataStatus.CONVERTING) {
      setUploadStatus(true)
    } else {
      setUploadStatus(false)
    }
  }

  return (
    <div className={styles.index}>
      <Head>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={t("meta-keywords")} />
        <meta property="og:title" content={seoData.title} />
        <meta property="og:description" content={seoData.description} />
      </Head>
      <Header />
      {showWarnTips ? (
        <div className={styles.warnTips}>
          <img className={styles.icon} src={require("../pagesComp/index/image/ic_warn.png").default} alt="" />
          {t("Some files wrong")}
        </div>
      ) : null}
      <div className={styles.container} style={{ marginBottom: isMobile ? 0 : "60px" }}>
        <div className={styles.header}>
          <h1>{mainTitle}</h1>
          <h2>{seoData.title}</h2>
        </div>
        {!isMobile ? (
          !isConvert ? (
            <div className={styles.func}>
              <FileUpload
                fileList={fileList}
                onChange={fileListHandler}
                setFileList={setFileList}
                onConvert={onConvert}
              />
              <div className={styles.optionHeader}>
                <div
                  className={classnames({
                    [styles.formatHeader]: true,
                    [styles.showOptions]: optionVisible,
                  })}
                  onClick={() => setOptionVisible(!optionVisible)}
                >
                  <div className={styles.formatTxt}>
                    <span className="iconfont icon-setting"></span>
                    {t("Audio Options")}
                  </div>
                  <div className={optionVisible ? "iconfont icon-down active" : "iconfont icon-down"}></div>
                </div>
              </div>
              {optionVisible && (
                <>
                  <FormatList formatIndex={formatIndex} setFormatIndex={setFormatIndex} />
                  <QualityList sizeIndex={sizeIndex} setSizeIndex={setSizeIndex} />
                </>
              )}
            </div>
          ) : (
            <>
              <div className={styles.fileList}>
                {fileList.map((e, i) => (
                  <FileItem
                    key={`${e.name}-${e.size}`}
                    name={e.name}
                    size={e.size}
                    file={e}
                    isUpload
                    format={formats[formatIndex].targetValue}
                    quality={sizeLists[sizeIndex].value}
                    updateParentStatus={(status: ConvertDataStatus) => {
                      statusFn(status)
                    }}
                    onDelete={() => {
                      const flist = Array.from(fileList)
                      flist.splice(i, 1)
                      setFileList(flist)
                    }}
                  />
                ))}
              </div>
              <div
                className={styles.convertMoreBtn}
                onClick={convertMore}
                style={{ display: uploadStatus ? "none" : "flex" }}
              >
                <div className="iconfont icon-convert w"></div>
                <div className={styles.text}>{t("Convert more files")}</div>
              </div>
            </>
          )
        ) : !isConvert ? (
          <>
            <FileUpload
              fileList={fileList}
              onChange={fileListHandler}
              setFileList={setFileList}
              onConvert={onConvert}
            />
            <FormatList formatIndex={formatIndex} setFormatIndex={setFormatIndex} />
            <QualityList sizeIndex={sizeIndex} setSizeIndex={setSizeIndex} />
            {!!fileList.length && (
              <div className={styles.convertBtn} onClick={onConvert}>
                <div className="iconfont icon-convert w"></div>
                <div className={styles.text}>{t("Convert")}</div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className={styles.fileList}>
              {fileList.map((e, i) => (
                <FileItem
                  key={`${e.name}-${e.size}`}
                  name={e.name}
                  size={e.size}
                  file={e}
                  isUpload
                  format={formats[formatIndex].targetValue}
                  quality={sizeLists[sizeIndex].value}
                  updateParentStatus={(status: ConvertDataStatus) => {
                    statusFn(status)
                  }}
                  onDelete={() => {
                    const flist = Array.from(fileList)
                    flist.splice(i, 1)
                    setFileList(flist)
                  }}
                />
              ))}
            </div>
            <div
              className={styles.convertMoreBtn}
              onClick={convertMore}
              style={{ display: uploadStatus ? "none" : "flex" }}
            >
              <div className="iconfont icon-convert w"></div>
              <div className={styles.text}>{t("Convert more files")}</div>
            </div>
          </>
        )}
      </div>
      <Mp4Page postData={postData} />
      <Footer />
    </div>
  )
}

export default Mp3Page

 const _getServerSideProps: GetServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const { slug } = ctx.query
  const lang = ctx.locale as BaseHostKey
  const baseURL = baseHost[lang]

  const resList = await Promise.all([
    axios.get(`/pages?slug=${slug}`, {
      baseURL,
    }),
  ])

  const mainTitle = resList[0].data[0].title.rendered
  const postData = resList[0].data[0].content.rendered
  const seoData = resList[0].data[0].yoast_head_json

  return {
    props: {
      mainTitle: mainTitle,
      postData: postData,
      seoData: seoData,
    },
  }
}

export const baseHost = {
  en: "https://www.online-audioconvert.com/tutorials/wp-json/wp/v2/",
  es: "https://www.online-audioconvert.com/tutorials-es/wp-json/wp/v2/",
  pt: "https://www.online-audioconvert.com/tutorials-pt/wp-json/wp/v2/",
}

type BaseHost = typeof baseHost

export type BaseHostKey = keyof BaseHost


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  